<template>
  <!--div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-4">
          <div class="card-group mb-4">
            <div class="card p-4">
              <div class="card-body">
                <h1>{{$t('LOGIN')}}</h1>
                <p class="text-muted">{{$t('LOGINTOYOURACCOUNT')}}</p>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><icon icon="user"></icon></span>
                  <input type="text" v-model="username" v-on:keyup.13="login" class="form-control" v-bind:placeholder="$t('USERNAME')">
                </div>
                <div class="input-group mb-4">
                  <span class="input-group-addon"><icon icon="lock"></icon></span>
                  <input type="password" v-model="password" v-on:keyup.13="login" class="form-control" v-bind:placeholder="$t('PASSWORD')">
                </div>
                <div class="row">
                  <div class="col-12">
                    <p class="bg-danger" v-if="loginResponse.error && loginResponse.notice">{{loginResponse.notice}}</p>
                  </div>
                  <div class="col-12">
                    <button type="button" v-on:click.prevent="login" class="btn btn-primary px-4 float-right">{{$t('LOGIN')}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div-->

  <div class="app login">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="login-left">
            <img src="../../../assets/img/logo.svg" class="login-logo">
            <div class="login-fields">

              <div v-if="!showForgotPassword">
                <h1>{{$t('LOGINTOYOURACCOUNT')}}</h1>
                <!--p class="text-muted">{{$t('LOGINTOYOURACCOUNT')}}</p-->

                <b-form-fieldset v-bind:label="$t('USERNAME')" class="full-input-group mb-3" :class="{'two-factor-hidden': twoFactorAuth}">
                    <b-form-input type="text" v-model="username" v-on:keyup.13="login"></b-form-input>
                </b-form-fieldset>

                <b-form-fieldset v-bind:label="$t('PASSWORD')" class="full-input-group mb-3" :class="{'two-factor-hidden': twoFactorAuth}">
                    <b-form-input type="password" v-model="password" v-on:keyup.13="login"></b-form-input>
                </b-form-fieldset>

                <div class="row">
                  <div class="col-12">
                    <p class="bg-danger" v-if="loginResponse.error && loginResponse.notice">{{loginResponse.notice}}</p>
                  </div>
                  <div class="col-12">
                    <button type="button" v-on:click.prevent="login" class="btn-bis btn-primary w-100">{{$t('LOGIN')}}</button>
                  </div>
                  <div class="col-12 mt-3 text-center">
                    <a href="#" class="text-muted" v-on:click.prevent="toggleForgotPassword">{{$t('FORGOTPASSWORD')}}</a>
                  </div>
                </div>
              </div>

              <div v-if="showForgotPassword">
                <div v-if="resetPasswordResponse.success">
                  <h1>{{$t('RESETPASSWORD')}}</h1>
                  <div class="alert alert-success">
                    {{$t('PASSWORDINSTRUCTIONSSENTTEXT')}}
                  </div>
                  <div class="mt-3 text-center">
                    <a href="#" class="text-muted" v-on:click.prevent="toggleForgotPassword">{{$t('BACKTOLOGIN')}}</a>
                  </div>
                </div>

                <div v-else>
                  <h1>{{$t('RESETPASSWORD')}}</h1>
                  <p class="text-muted mb-4">{{$t('ENTERUSERNAMEFORRESET')}}</p>

                  <b-form-fieldset v-bind:label="$t('USERNAME')" class="full-input-group mb-3">
                      <b-form-input type="text" v-model="resetUsername" v-on:keyup.13="handleResetPassword"></b-form-input>
                  </b-form-fieldset>

                  <p class="bg-danger" v-if="resetPasswordResponse.error && resetPasswordResponse.notice">
                    {{resetPasswordResponse.notice}}
                  </p>

                  <div class="row">
                    <div class="col-12">
                      <button type="button" v-on:click.prevent="handleResetPassword" class="btn-bis btn-primary w-100" :disabled="!canSubmitReset">{{$t('SENDINSTRUCTIONS')}}</button>
                    </div>
                    <div class="col-12 mt-3 text-center">
                      <a href="#" class="text-muted" v-on:click.prevent="toggleForgotPassword">{{$t('BACKTOLOGIN')}}</a>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 hidden-on-small">
          <div class="login-tehnician"><img src="../../../assets/img/login-technician.png"></div>
          <div class="login-bg-img">&nbsp;</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Login',
  data: function()
  {
    return {
      username: '',
      password: '',
      twoFactorAuth: false,
      showForgotPassword: false,
      resetUsername: '',
      resetPasswordResponse: {}
    }
  },
  computed:
  {
    ...mapGetters([
      'loginResponse'
    ]),
    canSubmitReset: function()
    {
      return this.resetUsername && this.resetUsername.length > 0;
    }
  },
  methods:
  {
    ...mapActions({
      actLogin: 'login',
      actRequestResetPassword: 'requestResetPassword'
    }),
    login: function(bvEvt)
    {
      bvEvt.preventDefault();
      this.actLogin({username: this.username, password: this.password});
    },
    toggleForgotPassword: function()
    {
      this.showForgotPassword = !this.showForgotPassword;
      this.resetPasswordResponse = {};
      this.resetUsername = '';
    },
    handleResetPassword: async function(bvEvt)
    {
      if (bvEvt && bvEvt.preventDefault) {
        bvEvt.preventDefault();
      }

      if (!this.resetUsername) {
        return;
      }

      const response = await this.actRequestResetPassword({
        username: this.resetUsername
      });

      this.resetPasswordResponse = response;
    }
  }
}
</script>
